import xlogo_cn from '../assets/logos/xhorse_cn.png'
import xlogo_en from '../assets/logos/xhorse_en.png'
import login_logo_cn from '../assets/logos/login_xhorse_cn.png'
import login_logo_en from '../assets/logos/login_xhorse_en.png'
import tclogo from '../assets/logos/tc.png'
import login_tclogo from '../assets/logos/login_tc.png'

const config = {
    xhorse: {
        name: 'xhorse',
        onlyqr: 0,
        cn: xlogo_cn,
        en: xlogo_en,
        home_cn: login_logo_cn,
        home_en: login_logo_en,
        copyright: 'Copyright 2019- Xhorse. All Rights Reserved'
    },
    tc: {
        name: 'tc',
        onlyqr: 1,
        cn: tclogo,
        en: tclogo,
        home_cn: login_tclogo,
        home_en: login_tclogo,
        copyright: 'Copyright 2025- THINKCARD. All Rights Reserved'
    }
}

const project = config[process.env.PROJECT_ENV || 'xhorse']
export default project



// WEBPACK FOOTER //
// ./src/config/config.js